import React, { useState, useEffect } from 'react';
import HeroBannerDesktop from './banner/HeroBannerDesktop';
import HeroBannerMobile from './banner/HeroBannerMobile';

export default function HeroBanner({ videos, onPlay, onInfo }: { videos: any[], onPlay: (id: string) => void, onInfo: (id: string) => void }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 🚀 CIRÚRGICO: Removemos o bloqueio de 'shorts' ou 'feed' para o banner aceitar o topo
  const validVideos = videos;

  if (validVideos.length === 0) return null;

  if (isMobile) {
    return <HeroBannerMobile videos={validVideos} onPlay={onPlay} onInfo={onInfo} />;
  }

  return <HeroBannerDesktop videos={validVideos} onPlay={onPlay} onInfo={onInfo} />;
}